import { render, staticRenderFns } from "./penalty.vue?vue&type=template&id=37b1ffbc&scoped=true&"
import script from "./penalty.vue?vue&type=script&lang=js&"
export * from "./penalty.vue?vue&type=script&lang=js&"
import style0 from "./penalty.vue?vue&type=style&index=0&id=37b1ffbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b1ffbc",
  null
  
)

export default component.exports